import * as Butter from 'buttercms';
export const butterService = Butter('2509c8aead136ac65e9d0f5b40747b4e63ceb560');


